var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackerOrdered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-2{fill:none;stroke:#fff;stroke-width:2px}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_359",
    "data-name": "Group 359",
    transform: "translate(-634 -861)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_59",
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    "data-name": "Ellipse 59",
    transform: "translate(634 861)",
    style: {
      fill: "#00ff6f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_137",
    d: "M5360.5-11989.4l6.321 6.513 14.559-14.367",
    className: "prefix__cls-2",
    "data-name": "Path 137",
    transform: "translate(-4691.837 12892.25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_138",
    d: "M5375.354-11997.25l-7.854 8.237",
    className: "prefix__cls-2",
    "data-name": "Path 138",
    transform: "translate(-4693.474 12892.25)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_139",
    d: "M5352.75-11984.75l5.938 5.938 2.106-2.107",
    className: "prefix__cls-2",
    "data-name": "Path 139",
    transform: "translate(-4690.792 12888.562)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackerOrdered);
export default __webpack_public_path__ + "static/media/tracker-ordered.6c83faa7aa352675fe62760c0c1a975b.svg";
export { ForwardRef as ReactComponent };